import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleDomain, SecurityModuleName, SecurityRight } from '../security.module';


export enum PortalContractorSecurityRight {
    CanAccessJobs = 61000,
    ManageUsers = 61001,
    ManageCompliance = 61002,
    // CanKnowledgeBase = 61004,
    // 61005–61008 were the claims rights (Access / Manage Incoming / Outgoing Claims): nothing in the portal
    // read them and the portal has no claims page (WBS-11926). Never reuse these ids: roles may still store them.
    ModifyFormAfterSubmission = 61009,
    AddInviteUsers = 61010,
    AccessScheduler = 61011,
    TasksView = 61012,
    TasksCreate = 61013,
    TasksEdit = 61014,
    TasksDelete = 61015,
    ItemsView = 61016,
    ItemsCreate = 61017,
    ItemsEdit = 61018,
    ItemsDelete = 61019,
    SorsView = 61020,
    SorsCreate = 61021,
    SorsEdit = 61022,
    SorsDelete = 61023,
}

export class PortalContractorSecurityModule extends BaseSecurityModule<PortalContractorSecurityRight> {

    constructor() {

        super(
            SecurityModuleName.PortalContractors,
            [
                { _id: PortalContractorSecurityRight.CanAccessJobs, name: 'Access Work - Jobs', basic: true },
                { _id: PortalContractorSecurityRight.AccessScheduler, name: 'Access scheduler', basic: false },
                { _id: PortalContractorSecurityRight.ManageUsers, name: 'Manage Users', basic: false },
                { _id: PortalContractorSecurityRight.AddInviteUsers, name: 'Add / Invite Users', basic: false },
                { _id: PortalContractorSecurityRight.ManageCompliance, name: 'Manage Compliance', basic: false },
                { _id: PortalContractorSecurityRight.ModifyFormAfterSubmission, name: 'Modify Form After Submission', basic: false },
                { _id: PortalContractorSecurityRight.TasksView, name: 'Tasks › View', basic: false },
                { _id: PortalContractorSecurityRight.TasksCreate, name: 'Tasks › Create', basic: false },
                { _id: PortalContractorSecurityRight.TasksEdit, name: 'Tasks › Edit', basic: false },
                { _id: PortalContractorSecurityRight.TasksDelete, name: 'Tasks › Delete', basic: false },
                { _id: PortalContractorSecurityRight.ItemsView, name: 'Items › View', basic: false },
                { _id: PortalContractorSecurityRight.ItemsCreate, name: 'Items › Create', basic: false },
                { _id: PortalContractorSecurityRight.ItemsEdit, name: 'Items › Edit', basic: false },
                { _id: PortalContractorSecurityRight.ItemsDelete, name: 'Items › Delete', basic: false },
                { _id: PortalContractorSecurityRight.SorsView, name: 'SORs › View', basic: false },
                { _id: PortalContractorSecurityRight.SorsCreate, name: 'SORs › Create', basic: false },
                { _id: PortalContractorSecurityRight.SorsEdit, name: 'SORs › Edit', basic: false },
                { _id: PortalContractorSecurityRight.SorsDelete, name: 'SORs › Delete', basic: false },

            ] as SecurityRight<PortalContractorSecurityRight>[],
            SecurityModuleDomain.Portals
        );

        this.plan = TenantSubscription.Enterprise;
    }

}
